export default __webpack_public_path__ + "static/media/crypto-fund.1cc80cdd.png";